import { GMI, STATE } from "../../constants";
import request from "../request";
import replacement from "../../services/gma/replacement";


const { REPLACEMENT } = STATE.UI;

/**
 * @typedef { "charged_car_class" } FieldNames
 */

/** @type {Record<FieldNames, string>} */
const FIELD_PATHS = {
  charged_car_class: REPLACEMENT.SELECT_CAR_CLASS.CHARGED_CAR_CLASS
};

/**
 * Action creator for setting car class field
 * @private
 * @param {FieldNames} field - Dot notation path of the field
 * @param {unknown} value - Value to set
 * @returns {Object} Action object
 */
const setField = (field, value) => ({
  type: GMI.SET_GMI_STATE,
  path: FIELD_PATHS[field],
  value
});

/**
 * Action creator for clearing confirm field
 * @private
 * @param {FieldNames} field - Dot notation path of the field
 * @returns {Object} Action object
 */
const clearField = (field) => ({
  type: GMI.SET_GMI_STATE,
  path: FIELD_PATHS[field],
  value: null
});

export const selectCarClassState = {
  /**
   * @name set
   * @desc A global setter for ui.replacement.selectCarClass
   * @param {String} [field] - Name of the field to set
   * @param {Object} [value] - Value to set
   * @returns {Function} Dispatch function
   * @memberof actions.replacement.selectCarClassState
   * @example
   *
   * // Set charged_car_class
   * store.dispatch(actions.replacement.selectCarClassState.set('charged_car_class', 'TESTID'));
   *
   */
  set(field = null, value = {}) {
    return (dispatch) => {
      if (FIELD_PATHS[field]) return dispatch(setField(field, value));
    };
  },

  /**
   * @name unset
   * @desc Unsetter for ui.replacement.select_car_class
   * @param {String} [field] - Type of the field to unset
   * @returns {Function} Dispatch function
   * @memberof actions.replacement.selectCarClassState
   * @example
   *
   * // Unset the charged car
   * store.dispatch(actions.replacement.selectCarClassState.unset('charged_class_car'));
   */
  unset(field = null) {
    return (dispatch) => {
      if (FIELD_PATHS[field]) return dispatch(clearField(field));
    };
  }
};

/**
 * @desc gets data from replacement.ticket.car_class_details to be saved to ui.replacement.select_car_class
 * @param {Immutable} session - GMA session
 * @returns {Record<FieldNames, unknown>}
 */
export function getSelectCarClassState(session) {
  const carClassDetails = session.getIn(["replacement", "ticket", "car_class_details"])?.toJS();

  if (!carClassDetails) return;
  return carClassDetails?.code;
  
}

/**
 * Calls selectCarClass endpoint
 * @returns {Function} Dispatched service action
 */
export function selectCarClass() {
  return (dispatch, getState) => {
    const state = getState();

    const data = state.getIn(REPLACEMENT.SELECT_CAR_CLASS.CHARGED_CAR_CLASS).toJS();

    return dispatch(
      request({
        service: replacement.selectCarClass,
        data
      })
    );
  };
}